import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import productPricingSelector from 'yoda-site-components/lib/selectors/ProductPricingSelector';
import selectProductType from 'yoda-site-components/lib/selectors/productDetails/selectProductType';
import ImageBanner from 'yoda-site-components/lib/iris/wrappers/ImageBanner/ImageBanner';
import triggerPLCCAnalytics from 'yoda-site-components/lib/helpers/Utils/plccHelper';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import getCreditCardBannerData from '../../actions/CreditCardBannerAction';
import { creditCardBannerConst } from '../../helpers/ProductConstants';
import * as styles from '../ProductInfo/ProductInfo.css';

const cx = classNames.bind(styles);

const CreditCardBanner = (props) => {
    const { creditCardBannerData = {} } = useSelector((store) => store);
    const {
        analyticsAction: { plccApplyAnalytics },
    } = props;
    let isDataThere = false;

    const pricingDetails = useSelector((state) => productPricingSelector(false)(state));
    const productType = useSelector((state) => selectProductType(false)(state));
    isDataThere = !isEmpty(creditCardBannerData.channels);
    const creditCardLink = isDataThere ? creditCardBannerData?.channels[0]?.link?.url : '';
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(
            getCreditCardBannerData({ searchTerm: creditCardBannerConst.CREDIT_CARD_BANNER_TYPE })
        );
    }, []);
    useEffect(() => {
        triggerPLCCAnalytics(plccApplyAnalytics, {
            plccBanner: 'static_PDP_apply',
            href: creditCardLink,
        });
    }, [isDataThere]);
    let showBanner = false;
    const price = pricingDetails.defaults || pricingDetails.original;
    if (typeof price === 'string') {
        showBanner =
            price.replace(/\$/, '').replace(/,/g, '') >
                creditCardBannerConst.creditCardBannerPriceThreshold &&
            !isEmpty(creditCardBannerData.channels);
    } else if (productType && productType.templateType === 'bundle') {
        showBanner = !isEmpty(creditCardBannerData.channels);
    }
    if (showBanner) {
        return (
            <div
                className={`${cx('sm12', 'md12', 'lg12', 'xl12', 'creditcardBanner')} ${dt([
                    'sm:!px-0',
                    'pb-10',
                ])}`}
            >
                <ImageBanner
                    dataPlccName="static_PDP_apply"
                    channels={creditCardBannerData.channels}
                />{' '}
            </div>
        );
    }
    return null;
};

export default CreditCardBanner;
